export const FETCH_SALES = 'FETCH_SALES';